import axios from 'axios';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  async addPackageToParticipant(store, {participantID, packageID, amount}) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/packages/${packageID}/participants/${participantID}`,
      method: 'POST',
      data: { amount: Number(amount) },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('users/getParticipants', null, { root: true });
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async deletePackageFromParticipant(store, {participantID, packageID}) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/packages/${packageID}/participants/${participantID}`,
      method: 'DELETE',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('users/getParticipants', null, { root: true });
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
};

export default actions;